import api from '../../../constants/api';
import { isArrayValidAndNotEmpty } from '../../../constants/CommonUtil';
import { getEndOfDay, getStartOfDay } from '../../../constants/DateUtil';
import { getStringFromObject } from '../../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../../constants/nullCheckUtils';
import { COMBINEMODE, generateObjectWithCriteriaMode, getCombined } from '../../../sagas/util';

export const CORPORATE_SALES_DELIVERY_NOTES_DATE_FILTERS = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAYS: 'Past 7 Days',
    LAST_10_DAYS: 'Past 10 Days',
    LAST_30_DAYS: 'Past 30 Days',
    LAST_60_DAYS: 'Past 60 Days',
    LAST_90_DAYS: 'Past 90 Days',
    LAST_180_DAYS: 'Past 180 Days',
};

export const CORPORATE_SALES_STATE_FILTERS = [
    { key: 'draft', value: 'Draft' },
    { key: 'done', value: 'Done' },
    { key: 'cancel', value: 'Cancel' },
];

export const CORPORATE_SALES_TYPE_FILTERS = [
    { key: 'corporate_out', value: 'Corporate Delivery' },
    { key: 'inter_branch_out', value: 'Inter Branch Delivery' },
    { key: 'external_transfer_out', value: 'External Transfer Out' },
];

export const CORPORATE_SALES_TYPE_FILTERS_FOR_REFUNDS = [
    { key: 'corporate_in', value: 'Corporate Delivery In' },
    { key: 'inter_branch_in', value: 'Inter Branch Delivery In' },
    { key: 'external_transfer_in', value: 'External Transfer In' },
];

export const CORPORATE_SALES_DELIVERY_NOTES_FILTER_SCHEMA = (isRefund = false) => [
    {
        name: 'datePeriod',
        type: 'dateRange',
        label: 'Period',
        valueField: 'key',
        disableClear: true,
        showOnTop: true,
        options: Object.keys(CORPORATE_SALES_DELIVERY_NOTES_DATE_FILTERS).map(aPeriod => ({
            key: aPeriod,
            value: CORPORATE_SALES_DELIVERY_NOTES_DATE_FILTERS[aPeriod],
        })),
        defaultOption: {
            key: 'LAST_7_DAYS',
            value: 'Past 7 Days',
        },
        grid: 3,
        searchConstructFields: {},
    },
    {
        name: 'res_partner.id',
        type: 'autocomplete',
        label: 'Payer',
        valueField: 'id',
        disableClear: false,
        dataSourceConfig: {
            text: 'name',
            value: 'id',
        },
        dataSourceApi: api.SEARCH.PAYOR,
        searchConstructFields: {
            name: 'res_partner.id',
            filterOperation: '=',
        },
    },
    {
        name: 'status',
        type: 'select',
        label: 'Status',
        valueField: 'key',
        disableClear: true,
        options: CORPORATE_SALES_STATE_FILTERS,
        grid: 3,
        multiple: true,
        searchConstructFields: {
            name: 'stock_picking.state',
            filterOperation: '=',
        },
    },
    {
        name: 'type',
        type: 'select',
        label: 'Type',
        valueField: 'key',
        multiple: true,
        options: isRefund ? CORPORATE_SALES_TYPE_FILTERS_FOR_REFUNDS : CORPORATE_SALES_TYPE_FILTERS,
        grid: 3,
        searchConstructFields: {
            name: 'stock_picking.type',
            filterOperation: '=',
        },
    },
];

export const createSearchConstructForDeliveryNotes = (filters, isRefundPage) => {
    let searchConstruct = null;
    const datePeriod = getStringFromObject('datePeriod', filters);

    if (isObjectValidAndNotEmpty(datePeriod)) {
        const {
            startDate,
            endDate,
        } = datePeriod;
        if (startDate && endDate) {
            searchConstruct = getCombined(
                searchConstruct,
                COMBINEMODE.AND,
                getCombined(
                    generateObjectWithCriteriaMode(
                        'stock_picking.createDate',
                        getStartOfDay(startDate).getTime(),
                        '>=',
                    ),
                    COMBINEMODE.AND,
                    generateObjectWithCriteriaMode(
                        'stock_picking.createDate',
                        getEndOfDay(endDate).getTime(),
                        '<=',
                    ),
                ),
            );
        } else if (startDate) {
            searchConstruct = getCombined(
                searchConstruct,
                COMBINEMODE.AND,
                generateObjectWithCriteriaMode('stock_picking.createDate', getStartOfDay(startDate).getTime(), '>='),
            );
        } else if (endDate) {
            searchConstruct = getCombined(
                searchConstruct,
                'AND',
                generateObjectWithCriteriaMode('stock_picking.createDate', getEndOfDay(endDate).getTime(), '<='),
            );
        }
    }
    const types = getStringFromObject('type', filters);
    if (!isArrayValidAndNotEmpty(types)) {
        let typesConstruct = null;
        if (isRefundPage) {
            CORPORATE_SALES_TYPE_FILTERS_FOR_REFUNDS.forEach((aFilter) => {
                typesConstruct = getCombined(
                    typesConstruct,
                    'OR',
                    generateObjectWithCriteriaMode('stock_picking.type', aFilter.key, '='),
                );
            });
        } else {
            CORPORATE_SALES_TYPE_FILTERS.forEach((aFilter) => {
                typesConstruct = getCombined(
                    typesConstruct,
                    'OR',
                    generateObjectWithCriteriaMode('stock_picking.type', aFilter.key, '='),
                );
            });
        }
        searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, typesConstruct);
    }

    if (isObjectValidAndNotEmpty(filters)) {
        const searchText = getStringFromObject('searchText', filters);
        const textToSearch = (searchText || '').trim();
        if (textToSearch) {
            const searchTextConstruct = generateObjectWithCriteriaMode('stock_picking.name', searchText, ':');
            searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, searchTextConstruct);
        }
    }

    return searchConstruct;
};
